import { TemplateFormData } from "@dialogs/template-dialog/template-form.schema";
import {
  FieldRuleFieldSets,
  FieldRuleFilter,
  FormValue,
  RESPONSE_VIEW_MODE,
  UFormData,
} from "./form";
import { CreatedBy } from "./gql";

export const enum SystemAction {
  EDIT = "EDIT",
  DELETE = "DELETE",
  // ARCHIVE = "ARCHIVE",
  DUPLICATE = "DUPLICATE",
}

export const SystemActionOptions = [
  SystemAction.EDIT,
  SystemAction.DELETE,
  SystemAction.DUPLICATE,
] as const;

export const enum SystemField {
  CREATED_AT_COLUMN = "createdAtColumn",
  UPDATED_AT_COLUMN = "updatedAtColumn",
  CREATED_BY_COLUMN = "createdByColumn",
}

export const SystemFieldOptions = [
  SystemField.CREATED_AT_COLUMN,
  SystemField.UPDATED_AT_COLUMN,
  SystemField.CREATED_BY_COLUMN,
];

export const enum TemplateToolbar {
  ALLOW_DOWNLOAD_AS_EXCEL = "allowDownloadAsExcel",
  ALLOW_CREATE_NEW_RECORD = "allowCreatingNewRecord",
  ALLOW_DATA_FILTERING = "allowDataFilter",
}

export const TemplateToolbarOptions = [
  TemplateToolbar.ALLOW_DOWNLOAD_AS_EXCEL,
  TemplateToolbar.ALLOW_CREATE_NEW_RECORD,
  TemplateToolbar.ALLOW_DATA_FILTERING,
];

export const responseViewModes = [
  RESPONSE_VIEW_MODE.TABLE,
  RESPONSE_VIEW_MODE.CARD,
  RESPONSE_VIEW_MODE.DROPDOWN,
];

export interface ResponseTemplateData extends TemplateFormData {
  _id: string;
  formId: string;
  form?: UFormData;
  createdBy: Pick<CreatedBy, "name" | "profilePicture">;
  createdAt: string;
  showActionColumn: boolean;
  isParent?: boolean;
}
export interface TemplateField {
  alias?: string;
  isSingleField: boolean;
  questionIds: string[];
}
export type FormResponse = Record<string, FormValue | undefined>;

export type PrimaryFilterResponse = {
  id: string;
  title: string;
  config?: FieldRuleFilter;
  viewType?: PrimaryFilterViewType;
  answer?: FormValue;
  isDefault?: boolean;
};

export type PrimaryFilterResponseValue = {
  start: string;
  end: string;
  allowLeftSwipe?: boolean;
  allowRightSwipe?: boolean;
  responses: PrimaryFilterResponse[];
  config: FieldRuleFieldSets;
};

export type RepeaterResponseConfig = {
  formId: string;
  responseTemplateId?: string;
  label: string;
  responseId: string;
  questionId: string;
};

export type HeaderOption = { id: string; name: string };

export const enum PrimaryFilterViewType {
  CARD = "CARD",
  DROPDOWN = "DROPDOWN",
}
export const PrimaryFilterViewTypeArray = [
  PrimaryFilterViewType.CARD,
  PrimaryFilterViewType.DROPDOWN,
];
